<template>
    <div>
        <div class="extended_field" :class="{'extended_field-wide': !dynamic, 'extended_field-block': block}" v-for="(field, field_index) in d" v-bind:key="field_index">

            <label v-html="$root.t(field.name)" v-if="!hidetitle">
            </label>
            
            <input v-model="m[field.id]" :placeholder="hidetitle ? $root.t(field.name) : ''" v-if="field.type === 'text'" type="text" :name="`wf[${field.id}]`">

            <div class="select-wrapper" v-if="field.type === 'select'">
                <select v-model="m[field.id]" :name="`wf[${field.id}]`">
                    <option value="" selected v-html="hidetitle ? $root.t(field.name) : $root.t('option:deselected')"/>
                    <option v-for="(field_option, field_optkey) in field.value" v-bind:key="field_optkey" v-html="field_option.translation ? field_option.translation[$root.language] : field_option" :value="field_option.id ? field_option.id : field_optkey"/>
                </select>
            </div>

            <div class="radio" v-if="field.type === 'radio'" v-for="(field_option, field_optkey) in field.value"  v-bind:key="field_optkey">
                <label v-html="$root.t(field_option)"></label>
                <input v-model="m[field.id]" type="radio" :name="`wf[${field.id}]`" :value="field_option"/>
            </div>
            
            <div class="radio" v-if="field.type === 'checkbox'">
                <label v-html="$root.t(field.value)"></label>
                <input v-model="m[field.id]" type="checkbox" :name="`wf[${field.id}]`"/>
            </div>

            <a v-on:click="remove(field_index)" class="tag remove" v-if="dynamic"></a>
        
        </div>
        <div class="select-wrapper" v-if="dynamic">
            <select @change="onChange($event)" >
                <option value="" v-html="$root.t('extended_form:select:field')"></option>
                <option v-for="(options, optkey) in values" v-bind:key="options.id" v-html="$root.t(options.name)" :value="optkey">
                </option>
            </select>
        </div>          
    </div>          
</template>

<script>


export default {
  name: 'ExtendedFormField',
  props: ['values', 'data', 'model',  'dynamic', 'hidetitle', 'block'],
  data () {
      return {
          d: this.data,
          m: this.model
      }
  },
  methods: {
    onChange(event) {
        if (this.values[event.target.value]) {
          this.d.push(this.values[event.target.value])
            event.target.selectedIndex = 0;
        }
    },
    remove(item) {
        delete this.m[this.d[item].id];
        this.d.splice(item, 1);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@import '../main';

    .select-wrapper {
        display: inline-block;
        width: 100%;
        position: relative;
        cursor: pointer;
        &:after {
            content: " ";
            display: block;
            position: absolute;
            right: $padding / 1.5;
            z-index: 1000;
            width: $padding / 1.5;
            height: $padding / 1.5;
            border-left: 1.5px solid;
            border-bottom: 1.5px solid;
            top: $padding / 1.8;
            transform: rotate(-45deg);
            pointer-events: none;
            cursor: pointer;
        }
        &-multiple {
            &:after {
                display: none;
            }
            & > select {
                height: 12em;
            }
        }
    }
    
    .extended_field {

        width: 100%;
        
        & > label {
            margin-bottom: $padding;
            @include smallfont();
            font-weight: bold;
            display: block;
            width: 100%;
            padding: 0.5em 0;
            &.alert {
                color: red;
            }
            &.info {
                line-height: 1em;
                border-radius: 50%; 
                border: 1px solid; 
                height: 2em; 
                float: right; 
                display: inline-block; 
                width: 2em;
                color: white;
                background: black;
                text-align: center;
                cursor: pointer;
            }
        }

        input, .select-wrapper, textarea {
            margin-bottom: $padding;
            width: calc(100% - #{$padding * 3}) !important;
        }

        &-wide {
            .select-wrapper, input, textarea, table {
                width: 100% !important;
            }
        }
        &-block {
            width: calc(50% - 0.5em);
            display: inline-block;
            &:first-child {
                margin-right: 1em;
            }
        }

        .radio {
            display: inline-block;
            margin-right: $padding;
            margin-bottom: $padding / 2;
            padding-top: $padding / 3;
            padding-bottom: $padding / 3;
            label {
                display: inline;
                line-height: $padding * 1.5;
                margin: 0;
                margin-right: $padding;
                vertical-align: top;
            }
            input {
                margin: 0;
            }
        }
        .add,
        .remove {
            float: right;
            margin: 0;
            width: $padding * 2;
            border-radius: $padding;
            position: relative;
            height: $padding * 2;
            margin-top: 2px;
            color: $button-font-inactive;
            background: $button-inactive;
            border-color: $button-inactive;
            &:before, &:after {
                position: absolute;
                transition: all 0.1s;
                content: " ";
                left: $padding / 2;
                top: $padding;
                margin-top: -1px;
                border-bottom: 1px solid $button-font-inactive;
                width: $padding;
                transform: rotate(-45deg);
            }
            &:after {
                transform: rotate(45deg);
            }
            &:hover {
                color: $button-font-highlight;
                background: $button-highlight;
                border-color: $button-highlight;
                &:before, &:after {
                    border-bottom: 1px solid $button-font-highlight;
                }
            }
            &:active {
                color: $button-font-active;
                background: $button-active;
                border-color: $button-active;
                &:before, &:after {
                    border-bottom: 1px solid $button-font-active;
                }
            }
        }
        .add {
            &:before {
                transform: rotate(90deg);
            }
            &:after {
                transform: rotate(0deg);
            }
        }
           margin-bottom: $padding;

        .checkbox {
            margin:0;
            margin-bottom: $padding/2;
            input {
                vertical-align:middle;
                margin: 0;
                margin-right:$padding/2;
                display: inline-block;
            }
            span {
                vertical-align:middle; 
                display: inline-block; 
                width: 80%;
            }
        }
        .autoselect {
            vertical-align: top;
            padding-bottom: $padding;
            &-left, &-right {
                width: calc(50% - 0.5em) !important; 
                display: inline-block;
            }
            &-left {
                margin-right: $padding /2;
            }
            &-right {
                margin-left: $padding /2;
            }
            &-tags {
                border: 1px solid;
                overflow-y: auto;
                overflow-x: hidden;
                -webkit-overflow-scrolling: touch;
                height: $padding * 10.25;
                border-radius: 3px;
                a {
                    @include smallfont();
                    padding: 0.5em;
                    margin: 0.5em 0em 0em 0.5em;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 50%;
                }
                p {
                    padding: 0 $padding;
                }
            }
            &-ajax {
                position: relative;
                padding-bottom: $padding*2;
                input {
                    z-index: 1;
                    position: absolute;
                    top: 0px;
                    margin-top: 0px;
                }
                &-scroll {
                    overflow-y: auto;
                    overflow-x: hidden;
                    -webkit-overflow-scrolling: touch;
                    position: absolute;
                    left: 0px;
                    right: 0px;
                    bottom: 0px;
                    top: 0em; 
                    z-index: 2;
                    background: white;
                    box-shadow: $box-shadow;
                    height: 9.9em;
                    padding: 0;
                    margin-top: 2.5em;
                    border-radius: 3px;
                    background: $border-inactive-color;
                    a {
                        display: block;
                        border-bottom: 2px solid white;
                        padding: $padding/4 $padding;
                        &:hover {
                            background: $background-highlight;
                        }
                        span {
                            @include smallfont;
                        }
                    }
                }
            }
            &-table {
                border-collapse: collapse;
                vertical-align: top;
                display: block;
                position: relative;
                margin-bottom: 0.5em !important;
                tr {
                    background: $border-inactive-color;
                    border-top: 2px solid white;
                    &:first-child {
                        border-top: none;
                    }
                    td {
                        width: 100%;
                        vertical-align: middle;
                        padding: 5px 5px 0px 5px;
                        &:first-child {
                            padding-top: 0;
                        }
                        @include smallfont;
                    }
                }
            }
        }
        .table {
            table-layout: fixed;
            margin-bottom: $padding;
            td:last-child {
                width: 3em;
                text-align: right;
            }
            tr {
                margin: 0;
                height: 0em;
                padding: 0;
            }
            td {
                vertical-align: top;            
                height: 0em;
                input {
                    margin: 0;
                }
                a {
                    margin: 0 !important;
                    float: none !important;
                }
            }
            &-hash {
                margin-bottom: $padding * 2;
                td {
                    vertical-align: middle;            
                }
                td:last-child {
                    width: 70%;
                }
                td:first-child {
                    width: 30%;
                }
                td.inline {
                    text-align: left;
                    a {
                        display: inline-block;
                        margin-bottom: 0.5em !important;
                    }
                    input {
                        width: auto !important;
                    }
                }
            }
        }
        div {
            &.infotext {
                margin: 0 !important;
                overflow: hidden;
                p {
                    padding: $padding/2 0  !important;
                    @include smallfont();
                    margin: 0;
                    margin-bottom: $padding;
                }
            }
            &.divider {
                margin-bottom: $padding * 3;
            }
            &.title {
                border-bottom: 2px solid;
                margin-bottom: $padding;
                text-align: center;
            }
        }
    }
</style>



      